import { render, staticRenderFns } from "./DocumentsManage.vue?vue&type=template&id=4d84ea4d&"
import script from "./DocumentsManage.vue?vue&type=script&lang=js&"
export * from "./DocumentsManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports